module.exports = __webpack_public_path__ + "static/assets/ae64635916e1ddc8b0ac6bfd73c5cdf1.png";